import { Locale } from '@type/locale';
import { I18nString } from './i18n-string';

export class I18nStringMap {

    i18nStringMapId: string;
    i18nStrings: I18nString[];


    _selected:boolean;

    constructor() {
        this.i18nStrings = [];
    }

    public put( locale: Locale, value: string ) {
        let result: I18nString[] = this.i18nStrings.filter( x => x.locale == locale );
        if ( result.length != 0 ) {
            result[0].value = value;
        } else {
            let i18nString = new I18nString();
            i18nString.locale = locale;
            i18nString.value = value;
            this.i18nStrings.push( i18nString );
        }
    }

}
